/**
 * A project's statuses, in order — the API's `ProjectStatus` (2026-10-09). In
 * progress: draft, active, testing, on hold. Finished: support, completed.
 * Closed, taking no new tasks or tickets: completed, cancelled, archived.
 */
export const PROJECT_STATUSES = ['DRAFT', 'ACTIVE', 'TESTING', 'ON_HOLD', 'SUPPORT', 'COMPLETED', 'CANCELLED', 'ARCHIVED'];

/** Still being built: a contract running for one waits until it is finished. */
export const IN_PROGRESS_STATUSES = ['DRAFT', 'ACTIVE', 'TESTING', 'ON_HOLD'];

/**
 * The contracts running for a project — covering today (2026-10-27) — as `GET
 * /projects` and `/projects/:id` send them (`support`), and the ones in force
 * that start later (`upcoming`).
 */
export interface ProjectSupport {
  until: string | null;
  contracts: Array<{ number: string; startDate: string; endDate: string }>;
  upcoming?: Array<{ number: string; startDate: string; endDate: string }>;
}

export const NO_SUPPORT: ProjectSupport = { until: null, contracts: [], upcoming: [] };

/** A project as the status pieces read it. `supportByHand` — in support with no contract, by someone's choice. */
export interface ProjectStatusView {
  id: string;
  status: string;
  supportByHand?: boolean;
  support?: ProjectSupport;
}
